// extracted by mini-css-extract-plugin
module.exports = {"policy-and-terms":"styles_policy-and-terms__dVAaS","policy-and-terms__link":"styles_policy-and-terms__link__XD1Rt"};